import React from "react";
import { FrameView } from "components/FrameView/FrameView";

export const MeteorologicalMonitoring = () => {
  return (
    <FrameView
      title="Meteorological Monitoring"
      src="https://sc.smartkulsary.kz/meteorological/"
    />
  );
};
